import React, { useEffect } from "react";
import { IconButton } from "@mui/material";
import { RiFileExcel2Fill } from "react-icons/ri";

import { useDispatch, useSelector } from "react-redux";
import { getExcelList } from "../../store/actions/SparePartExcelActions";

export default function SparePartExcelToList(props) {
    const dispatch = useDispatch();

    const { SparePartExcel } = useSelector((state) => state);

    useEffect(() => {
        console.log(SparePartExcel);
        if (SparePartExcel?.excelList) {
            props.callBackTabData(SparePartExcel);
        }
    }, [SparePartExcel]);

    const checkFile = (event) => {
        if (event.target.files && event.target.files[0]) {
            let file = event.target.files[0];
            const formData = new FormData();
            formData.append("excelFile", file);
            props.setFormData(formData);

            let payload = {
                data: formData
            };

            dispatch(getExcelList(payload));
        }
    };

    return (
        <div>
            <IconButton
                id="spe_IconButton"
                component="label"
                disabled={props.disableExcel}
                size="large">
                <RiFileExcel2Fill id="spe_CreateNewFolder" style={{ width: 50, height: 50, fill: props.disableExcel ? "#bdbdbd" : "green" }} />
                <input id="spe_input" onChange={checkFile} type="file" style={{ display: "none" }} />
            </IconButton>
        </div>
    );
}
